import React, { PureComponent } from "react";
import VisualitzacioMapaLlegendaItem from "./VisualitzacioMapaLlegendaItem";
import styles from "./VisualitzacioMapaLlegenda.module.css";
import { colorsIcones } from "../../constantsObservacions";

const optionsLlegenda = [
  { color: colorsIcones["4"], descripcio: "Observador" }
];

function renderItemsLlegenda(optionsLlegenda) {
  return <VisualitzacioMapaLlegendaItem optionsLlegenda={optionsLlegenda} />;
}

class VisualitzacioMapaLlegenda extends PureComponent {
  render() {
    return (
      <div className={styles.MapaLlegenda}>
        {renderItemsLlegenda(optionsLlegenda)}
      </div>
    );
  }
}

export default VisualitzacioMapaLlegenda;
